import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop(props) {
    const location = useLocation();

    useEffect(
        function () {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
        [location.pathname],
    );

    return <>{props.children}</>;
}
